import { Injectable } from '@angular/core'
import { PortalGlobals } from '../portalglobals'
import { CurrentUser } from '../common/models/current-user'
import { Router, ActivatedRoute } from '@angular/router'
import { CurrentUserGateway } from '../common/gateways/current-user-gateway'
@Injectable()
export class AuthService {
    currentUser: CurrentUser
    constructor(public _global: PortalGlobals, private router: Router, private _currentUserGateway: CurrentUserGateway) {}

    isAuthorization(pageRoute: string): boolean {
        var isAuthorized = true

        // User Coming thorugh menu not by using the direct URL
        if (this._global.selectedPlanYear > 0) {
            return false
        }
        let route = location.href
        let planyear = this._global.selectedPlanYear

        if (localStorage.getItem('UserSessionContext') != undefined) {
            this.currentUser = JSON.parse(localStorage.getItem('UserSessionContext')!)
        } else {
            this._currentUserGateway.getCurrentUser().subscribe((user) => {
                if (user != null) {
                    //this._global.currentUser = user
                    this.currentUser = user
                }
            })
        }

        if (this.currentUser.insuranceCompanyName == this._global.insuranceCompanyNameSSI) {
            if (planyear == undefined || planyear == 0) {
                if (localStorage.getItem('PLANYEAR') != undefined && localStorage.getItem('PLANYEAR') != null) {
                    planyear = Number(localStorage.getItem('PLANYEAR'))
                }
            }

            if (planyear == 0) {
                return false
            } else {
                if (planyear >= this._global.Planyear2025) {
                    if (!(this.currentUser.IsDataEntrySpecialist || this.currentUser.IsRDCDataEntry || this.currentUser.IsDataEntryGroupSpecialist)) {
                        if (route.includes(pageRoute)) {
                            isAuthorized = false
                            this.router.navigate(['/' + this.currentUser.insuranceCompanyShortName.toLowerCase() + '/home'])
                        }
                    }
                }
            }
        }
        return isAuthorized
    }
}
